(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@projectstorm/react-diagrams-geometry"] = factory();
	else
		root["@projectstorm/react-diagrams-geometry"] = factory();
})(window, function() {
return 